export enum Country {
    VIETNAM = 'vn',
    ARGENTINA = 'ar'
}

export const TOOLS_UNSUPPORTED_COUNTRIES = [
    Country.VIETNAM
]


// WEBPACK FOOTER //
// ./ts/app/shared/types/countries.ts